import { TextButton } from '../util/button';
interface CheckInConfirmInfoCardProps {
  info: Record<string, string | string[]>[];
  header?: {
    label: string;
    onEdit: () => void;
  };
}
export const CheckInConfirmInfoCard = ({
  info,
  header,
}: CheckInConfirmInfoCardProps) => {
  return (
    <div className={'check-in-confirm-field'}>
      {header && (
        <div className={'check-in-confirm-header'}>
          <div className={'confirm-header-label'}>
            <span>{header.label}</span>
          </div>
          <div className={'confirm-header-button'}>
            <TextButton label={'編集する'} onClick={header.onEdit} />
          </div>
        </div>
      )}
      <div className={'check-in-confirm-card'}>
        {info.map((item, idx) => {
          const [[label, value]] = Object.entries(item);
          return (
            <div className={'check-in-confirm-item'} key={idx}>
              <div className={'confirm-item-label'}>
                <span>{label}</span>
              </div>
              <div className={'confirm-item-info'}>
                {Array.isArray(value) ? (
                  value.map((item, idx) => <span key={idx}>{item}</span>)
                ) : (
                  <span>{value}</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
